import React, { Suspense, lazy } from 'react';
import { useSelector } from 'react-redux';
import http from '../services/api/httpService';
import { tokenKey } from '../services/localStorage/authStorage';
import Notification from '../components/common/Notification';
import TLFullScreenLoader from '../components/common/TL-FullScreenLoader';

const COMPONENTS = {
  EmbeddedComponent: lazy(() => import('../components/admin/EmbeddedComponent')),
  ImportSession: lazy(() => import('../screens/admin/ImportSession')),
  ProviderServiceMappings: lazy(() => import('../screens/admin/ProviderServiceMappings')),
};

const LoadingMessage = () => <div>Loading component from server...</div>;
const NotFoundMessage = () => <div>Component not found.</div>;

const Embedded = ({ name }) => {
  const showFullScreenLoader = useSelector((state) => state.general.showFullScreenLoader);
  // Set during render so the token is in place before the lazy screen mounts.
  // A useEffect is too late once that chunk is cached: the screen's effect
  // would send the first request with no Authorization header.
  const token = sessionStorage.getItem(tokenKey);
  if (token) {
    http.setToken(token);
  }

  const SelectedComponent = COMPONENTS[name] || NotFoundMessage;

  return (
    <>
      <Notification />
      {showFullScreenLoader ? <TLFullScreenLoader /> : null}
      <Suspense fallback={<LoadingMessage />}>
        <SelectedComponent />
      </Suspense>
    </>
  );
};
export default Embedded;
